import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Section, SectionHeading, PageHero } from "../components/site/section";
import { PageCta } from "../components/site/page-cta";
import { Button } from "../components/ui/button";
import { asset } from "../lib/assets";

const bvsLogo = { url: asset("bvs-logo.png") };

const steps = [
    { step: "01", title: "Get the alert.", body: "New violations and hearing dates reach your dashboard, email and phone." },
    { step: "02", title: "Hit Resolve.", body: "One click on the dashboard or email, or reply RESOLVE to the text. Select one violation or many." },
    { step: "03", title: "Get a proposal.", body: "Scope, deadline and cost, sent to you for approval." },
    { step: "04", title: "Follow it to closed.", body: "The status updates in Violerts as the work moves." },
];
function Resolution() {
    return (<>
      <PageHero title="Don't just get alerted. Get it resolved." description="Violerts works with Building Violation Solutions (BVS) to cure your violations. We flag it, you click Resolve, and it gets handled from filing to certified correction."/>

      <Section>
        <SectionHeading title="How it works" align="center"/>
        <div className="relative mt-14">
          <span aria-hidden className="absolute left-7 right-[calc(25%-52px)] top-7 hidden h-px bg-border md:block"/>
          <ol className="grid grid-cols-1 gap-10 md:grid-cols-4 md:gap-8">
            {steps.map((s) => (<li key={s.step} className="relative flex flex-col items-start">
                <span aria-hidden className="relative z-10 mb-6 flex h-14 w-14 shrink-0 items-center justify-center rounded-full border border-border bg-background font-display text-sm font-bold text-foreground ring-8 ring-background">
                  {s.step}
                </span>
                <h2 className="text-xl font-semibold">{s.title}</h2>
                <p className="mt-2 text-sm leading-relaxed text-muted-foreground">{s.body}</p>
              </li>))}
          </ol>
        </div>
      </Section>

      <Section className="border-y border-accent/30 bg-mint-wash">
        <div className="mx-auto flex max-w-3xl flex-col items-center text-center">
          <p className="font-display text-3xl font-semibold leading-snug md:text-5xl">
            Violerts works hand-in-hand with Building Violation Solutions Inc.
          </p>
          <p className="mx-auto mt-4 max-w-2xl text-base leading-relaxed text-foreground/70 md:text-lg">
            When a violation needs boots-on-the-ground expertise, Violerts connects you directly with BVS — a team that specializes in navigating NYC DOB, HPD, ECB and OATH violations from filing to certified correction.

          </p>
          <img src={bvsLogo.url} alt="Building Violation Solutions Inc. logo" width={1320} height={843} className="mx-auto mt-8 w-52 max-w-full md:w-64"/>
          <div className="mt-8 flex flex-col items-center justify-center gap-3 sm:flex-row">
            <Button asChild size="lg">
              <Link to="/contact?category=Violation%20Resolution">Request a resolution</Link>
            </Button>
            <Button asChild variant="outline" size="lg">
              <a href="https://bvs.nyc" target="_blank" rel="noreferrer">
                Visit BVS <ArrowUpRight className="h-4 w-4"/>
              </a>
            </Button>
          </div>
        </div>
      </Section>

      <PageCta />
    </>);
}

export default Resolution;
